import axios from 'axios'

import { COP_COMMON_ERROR_MESSAGES } from '../constants/common-error-messages'
import { ASSETS_BASE_ENDPOINT, COP_API_BASE_URL } from '../constants/service-endpoints'
import { ToastService } from './toast.service'
import { buildCopHeaders, getSilentToken } from './tokenUtils'

export interface AssetListParams {
  functionName: string
  categoryId: number
  top?: number
  skip?: number
  count?: boolean
  searchText?: string
}

export interface Asset {
  id: string
  name: string
  categoryId: number
  [key: string]: unknown
}

export interface AssetListResponse {
  '@odata.count'?: number
  value: Asset[]
}

function buildODataQuery(params: {
  count: boolean
  top: number
  skip: number
  searchText: string
}): string {
  const query = new URLSearchParams()
  query.set('$count', String(params.count))
  query.set('$top', String(params.top))
  query.set('$skip', String(params.skip))
  query.set('searchText', params.searchText)
  return `?${query.toString()}`
}

export async function fetchAssetListByProductCategory(
  params: AssetListParams,
): Promise<AssetListResponse | null> {
  const {
    functionName,
    categoryId,
    top = 100,
    skip = 0,
    count = true,
    searchText = '',
  } = params

  try {
    const token = getSilentToken()
    const url = `${COP_API_BASE_URL}${ASSETS_BASE_ENDPOINT}/${functionName}(categoryId=${categoryId})${buildODataQuery({ count, top, skip, searchText })}`
    const headers = buildCopHeaders(token)

    const response = await axios.get<AssetListResponse>(url, { headers })
    const { '@odata.count': odataCount, value } = response.data
    return { '@odata.count': odataCount, value }
  } catch (error) {
    const fallbackMessage = COP_COMMON_ERROR_MESSAGES['api-error'].message.replace(
      '{{action}}',
      COP_COMMON_ERROR_MESSAGES['api-error'].action['assets-by-category-loading'],
    )
    const message = error instanceof Error && error.message ? error.message : fallbackMessage
    ToastService.error(message)
    return null
  }
}

